import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import AdminOptionsNavigator from "../../../navigation/AdminOptionsNavigator";
import styles from "./adminOptions.module.css";

const AdminOptions = () => {
  const { rolePermissions } = useSelector((state) => state.user);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/admin-options/statistics">
              الإحصائيات
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/admin-options/app-admins">
              إدارة أدمن التطبيق
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/admin-options/control-ads">
              التحكم في الإعلانات
            </PageLink>
          </div>
          {rolePermissions.includes("upload-multi-purpose-images") && (
            <div className={styles.linkWrapper}>
              <PageLink destination="/dashboard/admin-options/multi-purpose-images">
                صور متعددة الاستخدام
              </PageLink>
            </div>
          )}
        </div>
      </HorizantalBar>

      <AdminOptionsNavigator />
    </div>
  );
};

export default AdminOptions;
